const mParticle = require('./mparticle');
const branch = require('./branch');
const googleAnalytics = require('./google-analytics');

const types = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  NAVIGATION: 'NAVIGATION',
  PAGE_VIEW: 'PAGE_VIEW',
  USER_ATTRIBUTES: 'USER_ATTRIBUTES',
  TRANSACTION: 'TRANSACTION',
  SOCIAL: 'SOCIAL',
};

const services = [mParticle, branch, googleAnalytics];

/**
 * Delegate calling function with `functionName` on services
 *
 * @param {string} functionName Function to call in active services
 * @param {*} options values for tracking
 * @returns {Promise<Object>} result of track calls
 */
function delegate(functionName, options) {
  const validServices = services.filter(
    s => s.isActive() && typeof s[functionName] === 'function'
  );
  if (validServices.length === 0) {
    return Promise.resolve({ done: false });
  }

  const trackCalls = validServices.map(service =>
    service[functionName](options)
  );

  return Promise.all(trackCalls).then(() => ({ done: true }));
}

/**
 * Track using available integrations based on type
 *
 * @param {Object} options track options
 * @returns {Promise<Object>} result of track
 */
function track(options) {
  switch (options.type) {
    case types.PAGE_VIEW:
      return delegate('trackPageView', options);

    case types.NAVIGATION:
      return delegate('trackNavigation', options);

    case types.LOGIN:
      return delegate('trackLogin', options);

    case types.LOGOUT:
      return delegate('trackLogout', options);

    case types.SOCIAL:
      return delegate('trackSocial', options);

    case types.TRANSACTION:
      return delegate('trackTransaction', options);

    case types.USER_ATTRIBUTES:
      return delegate('trackUserAttributes', options);

    default:
      return Promise.reject(
        new Error(`Track failed. Unknown type given: ${options.type}`)
      );
  }
}

module.exports = { track, types };
